module.exports = __webpack_public_path__ + "static/media/apartment19.51832966.jpg";